/*
 * Copyright (c) 2023 Bolmate B.V.
 */
import './style/periodPicker.scss';

import {CloseButton, SelectItemShape, WithBackground} from '@dvrd/dvr-controls';
import IDate from '@dvrd/idate';
import React, {PureComponent} from 'react';
import {DashboardPeriod, DashboardPeriods, PeriodKey} from "../../../util/interfaces";
import {BolmateButton, BolmateSelect, DvrdDatePicker} from "../../controls";
import {getDashboardPeriod} from "../../../util/utils";

interface Props {
    onSubmit: (period: DashboardPeriod | null) => void;
    period: DashboardPeriod | null;
}

interface State {
    active: boolean;
    period: DashboardPeriod | null;
}

export default class PeriodPicker extends PureComponent<Props, State> {
    private selectItems: SelectItemShape[] = DashboardPeriods.map((period: DashboardPeriod) => ({
        value: period.key,
        label: period.label,
    }));

    constructor(props: Props) {
        super(props);
        this.state = {
            active: false,
            period: props.period,
        }
    }

    activate = () => {
        this.setState({active: true})
    };

    onClose = () => {
        this.setState({active: false});
    };

    onSubmit = () => {
        this.onClose();
        this.props.onSubmit(this.state.period);
    };

    onSelect = (value: PeriodKey) => {
        const period = getDashboardPeriod(value);
        this.setState({period});
    }

    onChangePeriodStart = (value: IDate) => {
        const period = Object.assign({}, this.state.period, {periodStart: value});
        this.setState({period});
    };

    onChangePeriodEnd = (value: IDate) => {
        const period = Object.assign({}, this.state.period, {periodEnd: value});
        this.setState({period});
    };

    render = () => {
        const {active, period} = this.state;
        return (
            <WithBackground active={active} onClose={this.onClose}>
                <div className='period-picker default-popup'>
                    <div className='header-container'>
                        <label className='header-title'>Periode aanpassen</label>
                        <CloseButton onClick={this.onClose}/>
                    </div>
                    <div className='body-container'>
                        <BolmateSelect value={period?.key ?? ''} onChange={this.onSelect} items={this.selectItems}
                                       label='Periode' className='period-select'/>
                        <div className='periods'>
                            <DvrdDatePicker onChange={this.onChangePeriodStart} value={period?.periodStart ?? null}
                                            label='Vanaf' disabled={period?.key !== PeriodKey.CUSTOM}
                                            dateFormat='DD-MM-YYYY' placeholder='dd-mm-jjjj' closeOnChange/>
                            <DvrdDatePicker onChange={this.onChangePeriodEnd} value={period?.periodEnd ?? null}
                                            label='Tot en met' disabled={period?.key !== PeriodKey.CUSTOM}
                                            dateFormat='DD-MM-YYYY' placeholder='dd-mm-jjjj' closeOnChange/>
                        </div>
                    </div>
                    <div className='footer-container'>
                        <BolmateButton onClick={this.onClose} label='Sluiten' secondary/>
                        <BolmateButton onClick={this.onSubmit} label='Toepassen'/>
                    </div>
                </div>
            </WithBackground>
        )
    }
}